// import { AiFileVerifyForm } from '@framework/common-web';
import { FormItem, SelectInput } from '@framework/form';
import { Flex } from 'antd';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.FileType}`;

export interface IFileTypeRuleComponentProps {}

export function FileTypeRuleComponent(props: IFileTypeRuleComponentProps) {
  return (
    <Flex vertical>
      <FormItem name={`${fieldName}.value`} label="Formati file ammessi">
        <$SpaceCompact block size="large">
          <SelectInput
            name={`${fieldName}.value`}
            mode="tags"
            style={{ width: '100%' }}
            placeholder="Scrivi e premi invio per aggiungere..."
          />
          <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
        </$SpaceCompact>
      </FormItem>
      {/* //TODO AI Spostare in nuova Rule dedicata? gestire disabled */}
      {/* <AiFileVerifyForm disabled={undefined} /> */}
    </Flex>
  );
}
